export const URL_CONSTANTS = {
  sirius: 'https://www.siriuscom.com',
  allSpark : 'https://allspark.tech/'
};
